var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{attrs:{"large":_vm.isLessonView,"items":_vm.breadcrumbsItems},scopedSlots:_vm._u([(_vm.isLessonView)?{key:"item",fn:function({ item }){return [_c('v-breadcrumbs-item',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(item.text)+" ")])]}}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }